import { render, staticRenderFns } from "./HostingPagesSidebar.vue?vue&type=template&id=fd2fc686&scoped=true"
import script from "./HostingPagesSidebar.vue?vue&type=script&lang=js"
export * from "./HostingPagesSidebar.vue?vue&type=script&lang=js"
import style0 from "./HostingPagesSidebar.vue?vue&type=style&index=0&id=fd2fc686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2fc686",
  null
  
)

export default component.exports